import constants from "../../../utils/constants";
export var getStatusTone = function getStatusTone(status) {
  switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
    case constants.APPOINTMENT_STATUS.NO_SHOW:
      return {
        pill: "bg-red-900 border-red-600 text-white",
        date: "bg-red-900 border-red-600"
      };
    case constants.APPOINTMENT_STATUS.CANCELLED:
      return {
        pill: "bg-gray-900 border-gray-600 text-gray-600",
        date: "bg-gray-900 border-gray-600"
      };
    case constants.APPOINTMENT_STATUS.ENTERED_IN_ERROR:
      return {
        pill: "bg-gray-900 border-gray-600 text-gray-600 line-through",
        date: "bg-gray-900 border-gray-600"
      };
    case constants.APPOINTMENT_STATUS.CHECKED_IN:
    case constants.APPOINTMENT_STATUS.ARRIVED:
      return {
        pill: "bg-green-800 border-green-500 text-white",
        date: "bg-green-800 border-green-500"
      };
    case constants.APPOINTMENT_STATUS.FULFILLED:
      return {
        pill: "bg-green-900 border-green-600 text-white",
        date: "bg-green-900 border-green-600"
      };
    case constants.APPOINTMENT_STATUS.PENDING:
    case constants.APPOINTMENT_STATUS.PROPOSED:
      return {
        pill: "bg-yellow-900 border-yellow-600 text-white",
        date: "bg-yellow-900 border-yellow-600"
      };
    case constants.APPOINTMENT_STATUS.BOOKED:
      return {
        pill: "bg-gray-800 border-gray-700 text-white",
        date: "bg-gray-800 border-gray-700"
      };
    case constants.APPOINTMENT_STATUS.WAITLIST:
      return {
        pill: "bg-gray-900 border-gray-600 text-gray-600",
        date: "bg-gray-900 border-gray-600"
      };
    default:
      return {
        pill: "bg-gray-900 border-gray-600 text-white",
        date: "bg-gray-900 border-gray-600"
      };
  }
};